<div class="container">
  <h2 class="text-center mt-3">
    <img width="90" height="45"
         src="https://www.viniinternational.com/wp-content/uploads/2022/02/website-logo-main.png"
         alt="website-logo-main" loading="lazy"> <span>Cosmetics</span>
  </h2>
  <div *ngIf="isLoadingSpinner" class="col-12 text-center">
    <i class="fa fa-spinner fa-spin fa-4x text-secondary"></i>
  </div>
  <div *ngIf="qrCodeVerificationResponse">
    <div class="card verified-info text-center">
      <!--      <div>Welcome to Vini Cosmetics BD. This product code <span class="font-weight-bold text-primary">{{uid}}</span> is already being used</div>-->
      <div>Welcome to Vini Cosmetics BD. This product code <span class="font-weight-bold text-primary">{{uid}}</span> is verified</div>
      <div>You have already attempted both by scanning
        <span class="font-weight-bold">({{qrCodeVerificationResponse?.qrVerificationCountScan || 0}})</span> and SMS
        <span class="font-weight-bold">({{qrCodeVerificationResponse?.qrVerificationCountSms || 0}})</span>
      </div>
      <div>Total Count = {{ qrCodeVerificationResponse.qrVerificationCountScan + qrCodeVerificationResponse.qrVerificationCountSms }}</div>
      <div>Thank you for being with Vini</div>
    </div>

    <div class="text-success text-center mt-3 font-weight-bold"
         *ngIf="qrCodeVerificationResponse.customerFeedbackSubmitted || isSubmittedFeedback">
      You have already given your feedback
    </div>

    <div class="mt-3" *ngIf="!qrCodeVerificationResponse.customerFeedbackSubmitted && !isSubmittedFeedback">
      <div class="text-primary">Please submit your feedback about this product</div>
      <div class="card p-2">
        <form [formGroup]="customerFeedbackFg" class="mt-2">
          <div class="row">
            <div class="col-md-6 col-sm-12 mb-3">
              <label for="name" class="form-label">Name</label>
              <input type="text" class="form-control" formControlName="name" id="name">
            </div>
            <div class="col-md-6 col-sm-12 mb-3">
              <label for="mobileNo" class="form-label">Mobile No.</label>
              <input type="text" class="form-control" formControlName="mobileNumber" id="mobileNo">
            </div>
            <div class="col-md-6 col-sm-12 mb-3">
              <label for="location" class="form-label">Location</label>
              <input type="text" class="form-control" formControlName="purchaseLocation" id="location">
            </div>
            <div class="col-md-6 col-sm-12 mb-3">
              <label for="feedback" class="form-label">Comment/Feedback</label>
              <input type="text" class="form-control" formControlName="opinion" id="feedback">
            </div>
            <div class="col-12 text-center">
              <button type="button" class="btn btn-secondary mr-2" (click)="resetCustomerFeedback()">Reset</button>
              <button type="button" class="btn btn-primary"
                      [disabled]="isSaving"
                      (click)="submitCustomerFeedback()">Submit</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

